module.exports = __webpack_public_path__ + "img/vanke_icon.a9d86a0d.png";